import { TextField, TextFieldProps } from '@mui/material';

const CadisTextField = (props: TextFieldProps) => {
  return (
    <TextField {...props} InputLabelProps={{ shrink: true, }} size="small" fullWidth />
  )
}

export default CadisTextField